// extracted by mini-css-extract-plugin
export default {"toggler":"ScoreToggler_toggler__6M4Sn"};